import { z } from 'zod';

export const JE_HEADERS_CONFIG_TYPE = 'journal_entry_headers';

export const JeHeadersConfigsQuerySchema = z.object({
  type: z.literal(JE_HEADERS_CONFIG_TYPE),
});

// loose: other clients store fields this app does not read (`userMandatory`), and every save sends the config back
export const JeHeadersConfigSchema = z.looseObject({
  positions: z.record(z.string(), z.string()).default({}),
  hidden: z.array(z.string()).default([]),
  shown: z.array(z.string()).default([]),
  locked: z.array(z.string()).default([]),
});

export const JeHeadersConfigsResponseSchema = z.object({
  result: z.array(z.looseObject({ name: z.string(), config: JeHeadersConfigSchema })),
});

export const JeHeadersConfigSaveBodySchema = z.object({
  name: z.string().min(1),
  company_id: z.string(),
  type: z.literal(JE_HEADERS_CONFIG_TYPE),
  config: JeHeadersConfigSchema,
});

// The configs API answers errors with 403 / 404 / 409, never with 200 and an `error` field.
export const JeHeadersConfigSaveResponseSchema = z.looseObject({});

export const JeHeadersConfigPropagateBodySchema = z.object({
  name: z.string().min(1),
  company_ids: z.array(z.string()).min(1),
});

export const JeHeadersConfigPropagateResponseSchema = z.object({
  copied: z.number(),
});
